<template>
  <b-dropdown
    size="sm"
    :text="selected.label"
    variant="light"
    class="filtro-dropdown"
  >
    <b-dropdown-item
      v-for="option in options"
      :key="option.id"
      :active="selected?.id === option.id"
      @click="changed(option)"
    >
      {{ option.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "FiltroComparativo",

  props: {
    // 'semana' | 'mes' | 'semestre' | 'ano'
    defaultMode: { type: String, default: "ano" },
    // se true, emite @change-comparacao no mounted
    autoApplyOnMount: { type: Boolean, default: true },
  },

  data() {
    return {
      options: [
        // { id: "semana", label: "Semana atual vs. anterior" },
        // { id: "mes", label: "Mês atual vs. anterior" },
        // { id: "semestre", label: "Semestre atual vs. anterior" },
        { id: "ano", label: "Ano atual vs. anterior" },
      ],
      selected: null,
    };
  },

  mounted() {
    const start =
      this.options.find((o) => o.id === this.defaultMode) || this.options[0];
    this.selected = start;
    if (this.autoApplyOnMount) {
      this.emitRanges(start);
    }
  },

  methods: {
    // ===== Helpers de datas (ISO seguro no fuso local) =====
    toLocalISO(d) {
      const x = new Date(d);
      x.setMinutes(x.getMinutes() - x.getTimezoneOffset());
      return x.toISOString().slice(0, 10);
    },
    // segunda-feira da semana de 'date'
    startOfWeekMonday(date = new Date()) {
      const d = new Date(date);
      const dow = d.getDay(); // 0=dom,1=seg,...6=sáb
      const diffToMonday = dow === 0 ? 6 : dow - 1;
      d.setDate(d.getDate() - diffToMonday);
      d.setHours(0, 0, 0, 0);
      return d;
    },
    endOfWeekSunday(date = new Date()) {
      const start = this.startOfWeekMonday(date);
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      end.setHours(23, 59, 59, 999);
      return end;
    },
    startOfMonth(date = new Date()) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    },
    endOfMonth(date = new Date()) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    },
    startOfYear(date = new Date()) {
      return new Date(date.getFullYear(), 0, 1);
    },
    endOfYear(date = new Date()) {
      return new Date(date.getFullYear(), 11, 31);
    },

    // ===== Builders dos ranges A x B =====
    buildSemana() {
      const now = new Date();
      const aStart = this.startOfWeekMonday(now);
      const aEnd = this.endOfWeekSunday(now);

      const prev = new Date(aStart);
      prev.setDate(prev.getDate() - 1); // domingo anterior
      const bStart = this.startOfWeekMonday(prev);
      const bEnd = this.endOfWeekSunday(prev);

      return {
        modeId: "semana",
        label: "Semana atual vs. anterior",
        a: { inicio: this.toLocalISO(aStart), fim: this.toLocalISO(aEnd) },
        b: { inicio: this.toLocalISO(bStart), fim: this.toLocalISO(bEnd) },
      };
    },

    buildMes() {
      const now = new Date();
      const aStart = this.startOfMonth(now);
      // até HOJE no mês atual (mantém padrão usado em outros lugares)
      const aEnd = new Date(); // hoje

      const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const bStart = this.startOfMonth(prev);
      const bEnd = this.endOfMonth(prev);

      return {
        modeId: "mes",
        label: "Mês atual vs. anterior",
        a: { inicio: this.toLocalISO(aStart), fim: this.toLocalISO(aEnd) },
        b: { inicio: this.toLocalISO(bStart), fim: this.toLocalISO(bEnd) },
      };
    },

    buildSemestre() {
      const now = new Date();
      const m = now.getMonth(); // 0..11
      if (m <= 5) {
        // 1º semestre atual x 2º semestre anterior (ano passado)
        const aStart = new Date(now.getFullYear(), 0, 1);
        const aEnd = new Date(now.getFullYear(), 5, 30);

        const bStart = new Date(now.getFullYear() - 1, 6, 1);
        const bEnd = new Date(now.getFullYear() - 1, 11, 31);

        return {
          modeId: "semestre",
          label: "Semestre atual vs. anterior",
          a: { inicio: this.toLocalISO(aStart), fim: this.toLocalISO(aEnd) },
          b: { inicio: this.toLocalISO(bStart), fim: this.toLocalISO(bEnd) },
        };
      } else {
        // 2º semestre atual x 1º semestre do ano atual
        const aStart = new Date(now.getFullYear(), 6, 1);
        const aEnd = new Date(now.getFullYear(), 11, 31);

        const bStart = new Date(now.getFullYear(), 0, 1);
        const bEnd = new Date(now.getFullYear(), 5, 30);

        return {
          modeId: "semestre",
          label: "Semestre atual vs. anterior",
          a: { inicio: this.toLocalISO(aStart), fim: this.toLocalISO(aEnd) },
          b: { inicio: this.toLocalISO(bStart), fim: this.toLocalISO(bEnd) },
        };
      }
    },

    buildAno() {
      const now = new Date();
      const aStart = this.startOfYear(now);
      const aEnd = this.endOfYear(now);

      const bStart = this.startOfYear(new Date(now.getFullYear() - 1, 0, 1));
      const bEnd = this.endOfYear(new Date(now.getFullYear() - 1, 11, 31));

      return {
        modeId: "ano",
        label: "Ano atual vs. anterior",
        a: { inicio: this.toLocalISO(aStart), fim: this.toLocalISO(aEnd) },
        b: { inicio: this.toLocalISO(bStart), fim: this.toLocalISO(bEnd) },
      };
    },

    // ===== Emissão =====
    emitRanges(option) {
      let payload;
      switch (option.id) {
        case "semana":
          payload = this.buildSemana();
          break;
        case "mes":
          payload = this.buildMes();
          break;
        case "semestre":
          payload = this.buildSemestre();
          break;
        case "ano":
          payload = this.buildAno();
          break;
        default:
          payload = this.buildSemana();
          break;
      }
      this.$emit("change-comparacao", payload);
    },

    changed(option) {
      this.selected = option;
      // sempre emite (mesmo se selecionar a mesma opção)
      this.emitRanges(option);
    },
  },
};
</script>

<style>
.filtro-dropdown .dropdown-toggle {
  color: var(--primary-color);
}
</style>
